import { isPasswordColumn } from '@/components/record/fields/fieldKind';
import type { TableColumnStaticProps } from '@/types/tableTypes';

type ExportableColumn = Pick<TableColumnStaticProps, 'id' | 'header' | 'dataType' | 'cardOnly'>;

/** A column the export can carry. Display columns, such as Play, and card-only blocks have no value to export. */
export function isExportable(column: ExportableColumn): boolean {
    return column.dataType !== 'display' && !column.cardOnly;
}

/**
 * Whether a shown column starts ticked in the export column list. A login
 * password never does: the workbook would carry it readable, so the person
 * ticks it on purpose.
 */
export function isExportedByDefault(column: ExportableColumn): boolean {
    return isExportable(column) && !isPasswordColumn(column);
}

/**
 * The name the export column list shows for a column. A login password says
 * it will be readable in the workbook: "Password (readable)".
 */
export function exportColumnLabel(column: ExportableColumn): string {
    return isPasswordColumn(column) ? `${column.header} (readable)` : column.header;
}

/** Every column the export column list offers, with the name it shows. */
export function exportColumnOptionsFor(columns: ExportableColumn[]): { id: string; label: string }[] {
    return columns.filter(isExportable).map((column) => ({ id: column.id, label: exportColumnLabel(column) }));
}
